import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgressbar from 'react-circular-progressbar';
import colors from '../../../shared/styles/_colors.module.scss';
import SuccessGradient from '../../components/SuccessGradient/SuccessGradient';
import WarningGradient from '../../components/WarningGradient/WarningGradient';
import styles from './circularGauge.module.scss';
import 'react-circular-progressbar/dist/styles.css';

export default memo(function CircularGauge(props) {
    const [t] = useTranslation('common');

    const detail = props.exist ? `${props.percentage}%` : t('unavailable');
    const threshold = 70;
    const stroke = props.percentage >= threshold ? '#gradient-horizontal-warning' : '#gradient-horizontal-success';

    return (
        <>
            {props.percentage >= threshold && <WarningGradient />}
            {props.percentage < threshold && <SuccessGradient />}
            <CircularProgressbar
                className={styles.circularGauge}
                initialAnimation
                percentage={props.percentage}
                strokeWidth="4"
                styles={{
                    path: {
                        height: '100%',
                        stroke: `url(${stroke})`,
                        transition: 'stroke-dashoffset 2s ease 0s'
                    },
                    text: {
                        fill: colors.secondaryContentBackground,
                        fontSize: props.exist ? '1rem' : '0.6rem'
                    },
                    trail: { stroke: colors.transparentGrey }
                }}
                text={detail}
            />
        </>
    );
}, (prevProps, nextProps) =>
        prevProps.exist === nextProps.exist &&
        prevProps.percentage === nextProps.percentage
);
